import React from 'react';
import { useTranslation } from 'next-i18next';
import Router from 'next/router';
import { filter } from 'lodash';
import { useRouter } from 'next/router';
import { useWebshopState } from '@context/webshop';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

function IndexPage() {
  const { t } = useTranslation('webshop');
  const router = useRouter();
  const { id } = router.query;
  const { fetchWebshop, fetchUserCart } = useWebshopState();

  const goToHome = () => {
    Router.push({
      pathname: `/${id}`,
    });
  };

  React.useEffect(() => {
    if (id) {
      fetchWebshop(id);
      if (filter(JSON.parse(localStorage.getItem('userData')), { webShopToken: id }).length > 0) {
        const userData = filter(JSON.parse(localStorage.getItem('userData')), { webShopToken: id })[0];
        fetchUserCart({
          webShopToken: id,
          userId: userData.userId,
        });
      }
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container my-24 px-6 mx-auto">
      <section className="mb-32 text-gray-800 text-center">
        <div className="px-6 py-12 md:px-12">
          <h2 className="text-5xl my-12 font-bold tracking-tight">Vourity cookie policy</h2>
        </div>
        <div className="flex justify-center">
          <div className="block p-6 rounded-lg shadow-lg bg-white text-left grid justify-items-stretch">
            <p>Uppdaterade: 2019-01-28</p>
            <p>&nbsp;</p>
            <p>
              Denna cookie policy beskriver hur [Vourity AB], organisationsnummer [559140-9734] med adress [c/o Quick office 4-040, R&aring;sta strandv&auml;g 13C, 169 79 Solna, Sweden], (&rdquo;<strong>vi</strong>&rdquo; eller &rdquo;
              <strong>oss</strong>&rdquo;) anv&auml;nder cookies p&aring; [vourity.com och destinationspasset.se] (&rdquo;
              <strong>Hemsidan</strong>&rdquo;).
            </p>
            <p>
              En cookie &auml;r en liten textfil som s&auml;nds fr&aring;n en hemsida och som lagras i anv&auml;ndarens webbl&auml;sare, mobiltelefon eller annan enhet n&auml;r anv&auml;ndaren surfar p&aring; hemsidan. En cookie kan hj&auml;lpa hemsideleverant&ouml;ren att k&auml;nna igen din enhet n&auml;sta g&aring;ng du bes&ouml;ker hemsidan, ge dig tillg&aring;ng till vissa funktioner p&aring; hemsidan och/eller registrera dina surfvanor. Det finns andra teknologier s&aring; som pixeltaggar, beacons och andra liknande filer och teknologier som kan ha samma funktion som cookies. I denna cookie policy anv&auml;nder vi begreppet &rdquo;cookies&rdquo; f&ouml;r cookies och alla s&aring;dana
              liknande teknologier.
            </p>
            <p>Vi anv&auml;nder f&ouml;ljande cookies f&ouml;r syften som anges nedan:</p>
            <table border="1">
              <tbody>
                <tr>
                  <td width="142">
                    <p>
                      <strong>Funktionella cookies</strong>:
                    </p>
                  </td>
                  <td width="409">
                    <p>Vi anv&auml;nder funktionella cookies f&ouml;r att hantera vissa funktioner p&aring; Hemsidan i enlighet med dina val. Detta inneb&auml;r att n&auml;r du forts&auml;tter anv&auml;nda eller &aring;terv&auml;nder till Hemsidan, s&aring; kommer denna att tillhandh&aring;llas s&aring; som du tidigare beg&auml;rt, t.ex. genom att komma ih&aring;g ditt anv&auml;ndarnamn och anpassning av Hemsidan.</p>
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td width="142">
                    <p>
                      <strong>Analyscookies</strong>:
                    </p>
                  </td>
                  <td width="409">
                    <p>Vi anv&auml;nder analyscookies f&ouml;r att analysera hur tillg&aring;ng till Hemsidan sker, hur den anv&auml;nds eller fungerar. Vi anv&auml;nder informationen f&ouml;r att uppr&auml;tth&aring;lla, driva och f&ouml;rb&auml;ttra Hemsidan.</p>
                    <p>&nbsp;</p>
                  </td>
                </tr>
                <tr>
                  <td width="142">
                    <p>
                      <strong>Tredje parts-cookies</strong>:
                    </p>
                  </td>
                  <td width="409">
                    <p>Vi kan till&aring;ta v&aring;ra partners att anv&auml;nda cookies p&aring; Hemsidan f&ouml;r de syften som anges ovan. Vi kan ocks&aring; till&aring;ta tj&auml;nsteleverant&ouml;rer som agerar p&aring; v&aring;rt uppdrag att anv&auml;nda cookies f&ouml;r syften som anges ovan.</p>
                    <p>&nbsp;</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>De flesta webbl&auml;sare till&aring;ter att du hanterar hur du vill att cookies ska anv&auml;ndas. Du kan genom inst&auml;llningar i din webbl&auml;sare blockera cookies eller ta bort cookies. Generellt b&ouml;r du ocks&aring; kunna hantera liknande teknologier genom inst&auml;llningar i din webbl&auml;sare.</p>
            <p>V&auml;nligen notera att om du v&auml;ljer att blockera cookies kan funktionaliteten hos Hemsidan p&aring;verkas.</p>
            <p>Om du har fr&aring;gor eller kommentarer avseende anv&auml;ndande av cookies v&auml;nligen kontakta [privacy@vourity.com].&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
            <p>&nbsp;</p>
            <button type="button" onClick={() => goToHome()} className="mt-[20px] flex w-[180px] my-0 mx-auto px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
              {t('webshop.BACK_TO_START_PAGE')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export const getStaticPaths = async () => {
  return {
    paths: ['/id/cookie-policy'],
    fallback: true,
  };
};

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['webshop'])),
    },
  };
};

export default IndexPage;
